export default __webpack_public_path__ + "static/media/quiz.106be8a1.svg";